import { io } from 'socket.io-client';
import {
  API_URL,
  SESSION_EXPIRATION_TIME,
  SOCKET_INCOGNITO_URL,
  GET_SOCKET_URL,
} from './constants/global.constants';
import { session_tenantId, socketConfig, x_key } from './socket.config';
// import safelyParseJSON from './utils/safelyParseJson';

const SOCKET_URL = GET_SOCKET_URL();
let socket = io(SOCKET_URL, socketConfig);
export default socket;

export const setSocketURL = () => {
  socket = io(SOCKET_INCOGNITO_URL, socketConfig);
};

export const getExpirationTime = () => {
  return localStorage.getItem('session-expiration-time');
};

export const updateExpirationTime = () => {
  // If there is no expiration time, set it to 15 minutes from now
  const expirationTime = (
    new Date().getTime() +
    SESSION_EXPIRATION_TIME * 60 * 1000
  ).toString(); // 15 minutes in milliseconds
  localStorage.setItem('session-expiration-time', expirationTime);
};

// Function to store the session key in localStorage
export const storeSessionKey = (sessionKey: string) => {
  if (sessionKey) localStorage.setItem('x-session-key', sessionKey);
};

// Function to retrieve the session key from localStorage
export const getSessionKey = () => {
  return localStorage.getItem('x-session-key');
};

export const getSessionKeyApi = async () => {
  const storedSessionKey = getSessionKey();

  // Check if a session key is already stored and is still valid
  if (storedSessionKey /* && isSessionValid() */) {
    // You may want to add additional logic to check if the session is still valid
    return storedSessionKey;
  }

  const sessionUrl = API_URL + '/api/v1/session';
  const sessionRequestBody = {
    tenantId: session_tenantId,
  };

  try {
    const response = await fetch(sessionUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': x_key,
      },
      body: JSON.stringify(sessionRequestBody),
    });
    if (!response.ok) {
      console.error('HTTP error, status = ' + response.status);
      throw new Error('HTTP error, status = ' + response.status);
    }
    const responseData = await response.json();
    const sessionKey = responseData.data.sessionKey;
    // Setting a value in sessionStorage
    sessionStorage.setItem('x-session-key', sessionKey);
    if (sessionKey) localStorage.setItem('x-session-key', sessionKey);

    updateExpirationTime();

    return sessionKey;
  } catch (error: any) {
    console.error('Error: ' + error && error.message);
  }
};

const getUserNumber = () => {
  let userNumber = localStorage.getItem('userNumber');
  if (userNumber) {
    return userNumber;
  }
  const timestamp = performance.now();
  const fullTimestamp = Math.floor(Date.now() * 1000 + (timestamp % 1000));

  const timezoneOffset = new Date().getTimezoneOffset();
  const timezoneHours = Math.abs(Math.floor(timezoneOffset / 60))
    .toString()
    .padStart(2, '0');
  const timezoneMinutes = Math.abs(timezoneOffset % 60)
    .toString()
    .padStart(2, '0');
  const timezoneString = `${timezoneOffset <= 0 ? '-' : '-'}${timezoneHours}${timezoneMinutes}`;
    const random1 = Math.floor(10000 + Math.random() * 90000);
  const random2 = Math.floor(10000 + Math.random() * 90000);
  const clientType = process.env.REACT_APP_CLIENT;

  // const randomSixDigitNumber = Math.floor(100000 + Math.random() * 900000); // Generate a random 6-digit number

  switch (clientType) {
    case "salesbot2290ai":
      userNumber = `${fullTimestamp}-${random1}${random2}${timezoneString}@salesBot2290AI`;
      break;
    case "salesbottax1099":
      userNumber = `${fullTimestamp}-${random1}${random2}${timezoneString}@salesBotTax1099`;
      break;
    default:
      userNumber = `${fullTimestamp}-${random1}${random2}${timezoneString}@salesBot2290AI`;
      break;
  }

  localStorage.setItem('userNumber', userNumber);
  return userNumber;
};

// const getUserNumber = async () => {
//   let userNumber = localStorage.getItem('userNumber');
//   if (userNumber) {
//     return userNumber;
//   }

//   const timestamp = performance.now();
//   const fullTimestamp = Math.floor(Date.now() * 1000 + timestamp % 1000);

//   const timezoneOffset = new Date().getTimezoneOffset();
//   const timezoneHours = Math.abs(Math.floor(timezoneOffset / 60))
//     .toString()
//     .padStart(2, '0');
//   const timezoneMinutes = Math.abs(timezoneOffset % 60)
//     .toString()
//     .padStart(2, '0');
//   const timezoneString = `${timezoneOffset <= 0 ? '+' : '-'}${timezoneHours}${timezoneMinutes}`;

//   // const random1 = Math.floor(10000 + Math.random() * 90000);
//   const random2 = Math.floor(10000 + Math.random() * 90000);

//   // userNumber = `${fullTimestamp}-${random1}${random2}-${timezoneString}@Tax1099`;
//   userNumber = `${fullTimestamp}-${random2}-${timezoneString}@Tax1099`;

//   localStorage.setItem('userNumber', userNumber);
//   return userNumber;
// };
// const isChatInitiatedByUserKey = 'is-chat-initiated-by-user';

// const getInitialChatByUserOpen = () => {
//   const storedValue: string | any = localStorage.getItem(
//     isChatInitiatedByUserKey,
//   );
//   return Boolean(safelyParseJSON(storedValue));
// };


export const setSessionKey = async () => {
  try {
    const sessionKey = await getSessionKeyApi();

    if (!sessionKey) {
      console.error('Session key is not available.');
      return;
    }

    // Configure socket authentication properties
    socket.auth = {
      identifier: getUserNumber(),
      sessionKey: sessionKey,
      authToken: sessionKey.toString(),
    };


    // const allowToConnect = getInitialChatByUserOpen();
      socket.connect();
 
  } catch (error) {
    console.error('Error setting session key:', error);
  }
};
